export default {
  apiUrl: window.appSettings.API_URL,
};

const siteConfig = {
  siteName: 'Tracs',
  siteIcon: 'ion-md-globe',
  footerText: 'TraCS ©2020 Created by Technology Enterprise Group, Inc',
};
const themeConfig = {
  topbar: 'themelight',
  sidebar: 'themelight',
  layout: 'themelight',
  theme: 'themelight',
};
const language = 'english';

const jwtConfig = {
  fetchUrl: window.appSettings.API_URL,
  secretKey: 'secretKey',
};

export { siteConfig, language, themeConfig, jwtConfig };
